import {AxiosResponse} from 'axios'
import {corporateApi} from '../../../../setup/axios/CorporateApi'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'
import {IQuestionModel} from './QuestionModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const QUESTION_CREATE_URL = `${API_URL}api/v1/question/create`
export const QUESTION_GET_ALL_URL = `${API_URL}api/v1/question/getAll`
export const QUESTION_UPDATE_URL = `${API_URL}api/v1/question/update/`
export const QUESTION_DELETE_URL = `${API_URL}api/v1/question/delete/`

export function createQuestion(
  question: IQuestionModel
): Promise<AxiosResponse<ApiResponse<IQuestionModel>>> {
  return corporateApi.post(QUESTION_CREATE_URL, question)
}

export function loadQuestions(
  page = 0,
  size = 10
): Promise<AxiosResponse<ApiResponse<PageResponse<IQuestionModel>>>> {
  return corporateApi.get(QUESTION_GET_ALL_URL, {params: {page, size}})
}

export function updateQuestion(
  question: IQuestionModel
): Promise<AxiosResponse<ApiResponse<IQuestionModel>>> {
  return corporateApi.patch(QUESTION_UPDATE_URL + question.id, question)
}

export function deleteQuestion(questionId: string) {
  return corporateApi.delete(QUESTION_DELETE_URL + questionId)
}
